import { render, staticRenderFns } from "./OrderStoreReview.vue?vue&type=template&id=1f3be776"
import script from "./OrderStoreReview.vue?vue&type=script&lang=js"
export * from "./OrderStoreReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports